module.exports = __webpack_public_path__ + "img/ig.330ed39d.svg";